import React, { useEffect, useMemo, useState } from 'react'
import "./headerStyle.scss"
import Checkbox from "../checkbox/Checkbox";
import Checkbox1 from "../checkbox/Checkbox1";
import TimerControl from './TimerControl'
import { AuthState } from '../../../context/AuthProvider'
import ResultHeader from './ResultHeader'
import Buttons from './Buttons'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux';
import { SET_SERIES_TYPE, SelectSeriesType, SelectSeriesTypeDisableFlag } from "../../../redux/2d-slice/seriesSlice2d";
import { useNavigate } from "react-router-dom";
import { SocketState } from "../../../context/SocketProvider";

import { SelectGameID, SelectLastSaleAmount, SelectLastTicketId, SelectAnnoucements } from '../../../redux/2d-slice/gameInfo2dSlice';

import Marquee from "react-fast-marquee";
import SubHeader from './SubHeader';
function Header() {
  let annoucements = useSelector(SelectAnnoucements)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { socket } = SocketState()
  let { userDetail } = AuthState()
  let lastSaleAmount = useSelector(SelectLastSaleAmount)
  let lastTicketId = useSelector(SelectLastTicketId)
  let seriesType = useSelector(SelectSeriesType)
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag)
  let game_id = useSelector(SelectGameID)
  const [gameType, setGameType] = React.useState('2D');

  const [timer, setTimer] = useState(null)
  const handleGameTypeChange = (selectedGameType) => {
    setGameType(selectedGameType);
    localStorage.setItem("gameRoute", selectedGameType)
    // Example: Navigation
    if (selectedGameType === '3D') {
      socket.emit('req', {
        en: "LOTTARY_CLOSE_GAME",
        data: {}
      });
      navigate('/3d');
    } else {
      navigate('/2d');
    }
  };
  useEffect(() => {
    let timeInterval = setInterval(() => {
      setTimer(moment().format('hh:mm:ss A'))
    }, 1000);

    return () => {
      clearInterval(timeInterval)
    }
  }, [])

  return (
    <>
      {/* <div className="headerContainerannoucements" >
        <Marquee>
          <p className="text-white text-[12px]">{annoucements}</p>
        </Marquee>
      </div> */}
      <tr colSpan="2" align="left">
        <ResultHeader />
      </tr>
      <tr colSpan="2" style={{backgroundColor:'#d9d9d9'}}>
        <Buttons/>
      </tr>
      <tr colSpan="2">
        <SubHeader/>
      </tr>
      
    </>
  )
}

export default Header